import { useState } from 'react';
import { useModals } from '@mattjennings/react-modal-stack';
import { toast } from 'react-toastify';
import FNS from '../api';

const KINDS = {
    invoice: {
        title:   'Arve saadetud',
        noun:    'arve',
        confirm: 'Kinnita: arve on saadetud',
        toast:   'Arve märgitud saadetuks!',
    },
    prepayment: {
        title:   'Ettemaksu arve saadetud',
        noun:    'ettemaksu arve',
        confirm: 'Kinnita: ettemaksu arve on saadetud',
        toast:   'Ettemaksu arve märgitud saadetuks!',
    },
};

/**
 * Confirmation dialog for "Arve" / "Ettemaksu arve" in the job lifecycle.
 * Invoicing happens outside the platform; this only records the event, which
 * cannot be undone from the UI, hence the explicit confirmation.
 * `kind` is "invoice" (default) or "prepayment".
 */
function InvoiceSentModal({ open, id, jobNumber, kind = 'invoice', onConfirmed }) {
    const { closeModal } = useModals();
    const [ saving, setSaving ] = useState(false);
    const texts = KINDS[kind] || KINDS.invoice;

    async function onConfirm() {
        if(saving) return;
        setSaving(true);
        try {
            await FNS.markInvoiceSent(id, kind);
            toast.success(texts.toast);
            closeModal();
            if(onConfirmed) onConfirmed();
        } catch (e) {
            toast.error(e.message);
        } finally {
            setSaving(false);
        }
    }

    if(!open) return null;

    return (
        <div className='modal'>
            <div className='container column'>
                <div className="column p16 g16" style={{ maxWidth: 420 }}>

                    <div className="row g16 center-cross">
                        <h2 className='grow'>{texts.title}</h2>
                        <button onClick={closeModal} style={{ padding: 8 }} disabled={saving}>
                            <svg height="12" width="12" xmlns="http://www.w3.org/2000/svg" fill="#666" viewBox="0 0 490 490">
                                <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490   489.292,457.678 277.331,245.004 489.292,32.337 "/>
                            </svg>
                        </button>
                    </div>

                    <p>
                        Kinnita, et töö nr {jobNumber || '-'} {texts.noun} on kliendile saadetud.
                        Märge lisatakse töö elukaarde ja seda ei saa hiljem tagasi võtta.
                    </p>

                    <div className="row g8" style={{ justifyContent: 'flex-end' }}>
                        <button className="borderless" onClick={closeModal} disabled={saving}>Loobu</button>
                        <button onClick={onConfirm} disabled={saving} style={{ backgroundColor: '#8c8', color: 'white', fontWeight: 'bold' }}>{texts.confirm}</button>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default InvoiceSentModal;
